import { create } from 'zustand';

/**
 * Lightweight store to open/close the once-per-day Facebook promo modal.
 * The open decision (auth + route + `showAfterLoginModal` setting + per-day cookie)
 * lives in FacebookPromoModal; this store just holds the visible state so the modal
 * can also be opened manually from anywhere if ever needed.
 */
export const useFbPromoStore = create((set) => ({
    isOpen: false,
    openModal: () => set({ isOpen: true }),
    closeModal: () => set({ isOpen: false }),
}));
